<template>
    <div class="wrapper__header animate__animated animate__fadeInDown">
        <div class="wrapper__wpd over">
            <div class="fl" style="cursor: pointer" @click="preeItem('/')"><img :src="icon_logo" /></div>
            <div class="fr ">

                <el-dropdown v-for="(item, index) in cateList" :key="index" class="cate__ul" >
                    <router-link  class="el-dropdown-link cate__item" :class="{'cate__active': item.active}" tag="div" active-class="active" :to="item.path" >{{item.name}}</router-link>
                    <el-dropdown-menu class="cate__item--dropdown" slot="dropdown" >
                        <el-dropdown-item v-for="(it, ind) in item.child" :key="ind" v-if="item.child && item.child.length > 0">
                            <router-link tag="div" active-class="active" :to="it.path" >{{it.name}}</router-link>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
        </div>
    </div>
</template>

<script>
    import icon_logo from '@/assets/img/logo.png'
    import {cateList} from '@/libs/router'
    export default {
        name: 'Layouts',
        data (){
            return {
                icon_logo: icon_logo,
                cateList: [],
                noScroll: [
                    '/strategic/soft/1',
                    '/strategic/soft/2',
                    '/strategic/soft/0',
                    '/consultation/0',
                    '/consultation/100',
                    '/consultation/200',
                    '/consultation/300',
                    '/consultation/400',
                    '/consultation/500',
                    '/consultation/600',
                ]
            }
        },
        watch: {
            '$route' (to, form) {
                if (this.noScroll.indexOf(to.path) == -1){
                    window.scrollTo(0, 0)
                }
                this.cateList = this.cateList.map((val, key)=>{
                    val.active = false
                    if (to.path.indexOf(val.parentname) != -1 && val.parentname != '/'){
                        val.active = true
                    }
                    return val
                })
            }
        },
        components: {
        },
        computed: {
        },
        methods: {
            /**
             * @description点击跳转
             * */
            preeItem (path, query){
                this.$router.replace({path, query})
            },
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
            }
        },
        mounted(){
            this.$wow.init()
            this.cateList = cateList
            this.cateList = this.cateList.map((val, key)=>{
                val.active = false
                if (this.$route.path.indexOf(val.parentname) != -1 && val.parentname != '/'){
                    val.active = true
                }
                return val
            })
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper__header{
        min-width: 1400px;
        height: 74px;
        background: rgba(0,0,0,0.3);
        color: #fff;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 333;
        img{
            width: 208px;
            height: 46px;
            object-fit: contain;
            margin-top: 14px;
        }
        .el-dropdown{
            color: #fff;
            font-size: 16px;
            padding-left: 40px;
            font-weight: 500;
            line-height: 74px;
        }
        .cate__item{
            cursor: pointer;
            position: relative;
            padding: 0 25px;
        }
        .cate__item::after{
            content: "";
            width: 100%;
            height: 2px;
            background-color: #F55E1B;
            position: absolute;
            bottom: 0;
            left: 0;
            opacity: 0;
            visibility: hidden;
            -webkit-transition: all 0.3s ease 0s;
            transition: all 0.3s ease 0s;
            -webkit-transform: translateY(-10px);
            transform: translateY(-10px);
        }
        .router-link-exact-active.active::after, .cate__active::after{
            visibility: visible;
            opacity: 1;
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
        /*.cate__item.router-link-exact-active::after{*/
        /*    visibility: visible;*/
        /*    opacity: 1;*/
        /*    -webkit-transform: translateY(0);*/
        /*    transform: translateY(0);*/
        /*}*/
        .cate__item:hover{
            &::after {
                visibility: visible;
                opacity: 1;
                -webkit-transform: translateY(0);
                transform: translateY(0);
            }
        }
        .cate__item:focus{
            background:none;
            outline:none;
            border:none;
        }

    }
</style>
